import React, { useEffect } from 'react';
import './Listado.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles.css'

const Listado = ({ items, image, titulo }) => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return (
    <div className="porque-elegirme-container">
      <div className="porque-texto">
        <b><h2>{titulo}</h2></b>
        <ul>
          {items.map((item, index) => (
            <li key={index}
              data-aos="fade-right"
              data-aos-delay={index * 200}>{item}</li>
          ))}
        </ul>
      <div class="botones-container">
        <a href="servicios" class="button">
  Servicios
    <path
      clip-rule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      fill-rule="evenodd"
    ></path>
</a>

<a href="/resources/Costo de servicios actualizado.pdf" 
   download="Costo de servicios actualizado.pdf" 
   target='_blank'
class="button">
  Catálogo de servicios
  
    <path
      clip-rule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      fill-rule="evenodd"
    ></path>
</a>
</div>


      </div>
      <div className="porque-imagen">
        <img src={image} alt="Doctor Daniel Sánchez Sarabia" />
      </div>
    </div>
  );
};

export default Listado;
